/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { sideMenu } from "../Constants/menus";
import { logout } from "../Redux/User/actions";
import { alertBox, promptBox, alertNotify, alertAlertify, FeatherIcon, getIcon, toMoney } from "./Functions";
import Api from '../Server/Api';
import { v4 } from "uuid";

const api = new Api();

export const isTableInview = () => {
	const table = document.getElementsByClassName("datatable-toolbar app-table")
	return table.length > 0;
}


export const CircularMenu = (props) => {
	const [active, setActive] = React.useState(props?.initial || false);

	const [activity, setActivity] = React.useState(false);
	const [menu, setMenu] = React.useState(false);


	
	window.openActivityPanel = () => {
		if(isTableInview()) return;
		let a = document.getElementById("activity-panel");
		if(a){
			if(a.classList.contains("is-active")){
				a.classList.remove("is-active");
			}else{
				a.classList.add("is-active");
			}
		}
	}

	window.openAppMenu = () => {
		if(isTableInview()) return;
		let activity = document.getElementById("activity-panel")
		if(activity && activity?.classList?.contains("is-active")){
			activity.classList.remove("is-active")
			return;
		}
		openSubMenu();
	}
	
	const openSubMenu = () =>{
		let d = document.getElementsByClassName("navbar-burger");
		if(d && d?.item(0)) d.item(0).click();
	}

	return (
		<div
			id="circular-menu"
			className={`circular-menu ${active ? "active" : ""}`}
		>
			<a className="floating-btn" onClick={() => setActive(!active)}>
				<i aria-hidden="true" className="fas fa-bars" />
				<i aria-hidden="true" className="fas fa-times" />
			</a>
			<div className="items-wrapper">
				<div
					className="menu-item is-flex"
					onClick={() =>
						props?.changeTheme && props?.changeTheme(localStorage.theme)
					}
				>
					<label className="dark-mode">
						<input type="checkbox" defaultChecked />
						<span />
					</label>
				</div>
			
				<a
					href="/admin-profile-notifications.html"
					className="menu-item is-flex"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width={24}
						height={24}
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth={2}
						strokeLinecap="round"
						strokeLinejoin="round"
						className="feather feather-bell"
					>
						<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
						<path d="M13.73 21a2 2 0 0 1-3.46 0" />
					</svg>
				</a>
				<a
					className="menu-item is-flex right-panel-trigger"
					data-panel="activity-panel"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width={24}
						height={24}
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth={2}
						strokeLinecap="round"
						strokeLinejoin="round"
						className="feather feather-grid"
					>
						<rect x={3} y={3} width={7} height={7} />
						<rect x={14} y={3} width={7} height={7} />
						<rect x={14} y={14} width={7} height={7} />
						<rect x={3} y={14} width={7} height={7} />
					</svg>
				</a>
			</div>
		</div>
	);
};

const CombinedMenus = (props) => {
	const { hideCircularMenu } = props;
	const [is_menu_active, set_is_menu_active] = React.useState(false);
	const logout = () => {
		alertBox({
			title: "Logout",
			message: "You will be logged out, are you sure?",
			btnCallback: "Yes, Continue",
			callback: (e) => props.logout(),
		});
	}

	const deleteAccount = async (f) => {
		let data = {user: props?.user, password: f}
		const res = await api.del({ endpoint: "/users/",  data});
		if (res?.status){
			alertAlertify({
				title: "Account Deleted Successfully",
				message: "The account will be archived for 3 months, after which it will be permanently deleted from our system.",
				btnCallback: "Ok",
				closable: 0,
				callback: (e) => {
					props?.logout();
				}
			})
		}
		else{
			alertNotify({
				message:'Incorrect Password', 
				type: 'error',
				timeout: 3
			});
		}			
	}

	const deleteAccountAlert = () => {
		promptBox({
			title: "Account Delete",
			defaultValue: "",
			message:
					"<strong>Your account will be deleted, are you sure?<br/>Please enter your password<strong>",
			btnCallback: "Delete my account",
			callback: (e, f) => {
				deleteAccount(f);
			}			
		})		
	}

	return (
		<>
			{/*Mobile navbar*/}
			<nav
				className="navbar mobile-navbar no-shadow is-hidden-desktop is-hidden-tablet"
				aria-label="main navigation"
			>
				<div className="container">
					{/* Brand */}
					<div className="navbar-brand">
						{/* Mobile menu toggler icon */}
						<div className="brand-start">
							<div className="navbar-burger">
								<span />
								<span />
								<span />
							</div>
						</div>
						<a className="navbar-item is-brand" href="index.html">
							<img
								className="light-image"
								src={require("../assets/images/logo.png").default}
								alt=""
							/>
							<img
								className="dark-image"
								src={require("../assets/images/logo.png").default}
								alt=""
							/>
						</a>
						<div className="brand-end">
							<div className="navbar-item has-dropdown is-notification is-hidden-tablet is-hidden-desktop">
								<a
									className="navbar-link is-arrowless"
									href="javascript:void(0);"
								>
									<i data-feather="bell" />
									<span className="new-indicator pulsate" />
								</a>
								<div className="navbar-dropdown is-boxed is-right">
									<div className="heading">
										<div className="heading-left">
											<h6 className="heading-title">Notifications</h6>
										</div>
										<div className="heading-right">
											<a className="notification-link" href="#">
												See all
											</a>
										</div>
									</div>
									<div className="inner has-slimscroll">
										<ul className="notification-list">
											<li>
												<a className="notification-item">
													<div className="img-left">
														<img
															className="user-photo"
															alt
															src={require("../assets/images/placeholder.png").default}
															data-demo-src={
																require("../assets/img/avatars/photos/7.jpg")
																	.default
															}
														/>
													</div>
													<div className="user-content">
														<p className="user-info">
															<span className="name">Alice C.</span> left a
															comment.
														</p>
														<p className="time">1 hour ago</p>
													</div>
												</a>
											</li>
											<li>
												<a className="notification-item">
													<div className="img-left">
														<img
															className="user-photo"
															alt
															src={require("../assets/images/placeholder.png").default}
															data-demo-src={
																require("../assets/img/avatars/photos/12.jpg")
																	.default
															}
														/>
													</div>
													<div className="user-content">
														<p className="user-info">
															<span className="name">Joshua S.</span> uploaded a
															file.
														</p>
														<p className="time">2 hours ago</p>
													</div>
												</a>
											</li>
											<li>
												<a className="notification-item">
													<div className="img-left">
														<img
															className="user-photo"
															alt
															src={require("../assets/images/placeholder.png").default}
															data-demo-src="assets/img/avatars/photos/13.jpg"
														/>
													</div>
													<div className="user-content">
														<p className="user-info">
															<span className="name">Tara S.</span> sent you a
															message.
														</p>
														<p className="time">2 hours ago</p>
													</div>
												</a>
											</li>
											<li>
												<a className="notification-item">
													<div className="img-left">
														<img
															className="user-photo"
															alt
															src={require("../assets/images/placeholder.png").default}
															data-demo-src="assets/img/avatars/photos/25.jpg"
														/>
													</div>
													<div className="user-content">
														<p className="user-info">
															<span className="name">Melany W.</span> left a
															comment.
														</p>
														<p className="time">3 hours ago</p>
													</div>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							{/* Profile Section */}
							<div className="dropdown is-right is-spaced dropdown-trigger user-dropdown">
								<div className="is-trigger" aria-haspopup="true">
									<div className="profile-avatar">
										<img
											className="avatar"
											src={props?.user?.image || require("../assets/images/placeholder.png").default}
											data-demo-src={props?.user?.image}
											alt
										/>
									</div>
								</div>
								<div className="dropdown-menu" role="menu">
									<div className="dropdown-content">
										<div className="dropdown-head">
											<div className="h-avatar is-large">
												<img
													className="avatar"
													src={props?.user?.image || require("../assets/images/placeholder.png").default}
													data-demo-src={props?.user?.image}
													alt
												/>
											</div>
											<div className="meta">
												<span>{props?.user?.title} {props?.user?.name}</span>
												<span>{props?.user?.role}</span>
											</div>
										</div>

										{sideMenu.account.map((menu, i) => {
											if (menu.divider)
												return <hr key={v4()} className="dropdown-divider" />;
											return (
												<a key={v4()} href={menu.link} className="dropdown-item is-media">
													<div className="icon">
														<i className={menu.icon} />
													</div>
													<div className="meta">
														<span>{menu.name}</span>
														<span >
															{menu.description}
															{menu.name === "eWallet" && (
																<>
																<br/>
																<strong>Balance:</strong> {toMoney(props?.user?.wallet?.balance)} 
																</>
														)} </span>
													</div>
												</a>
											);
										})}

										<hr className="dropdown-divider" />
										<div className="dropdown-item is-button">
											<button className="button h-button is-primary is-raised is-fullwidth logout-button"
												onClick={() => logout()}
											>
												<span className="icon is-small">
													<i data-feather="log-out" />
												</span>
												<span>Logout</span>
											</button>
										</div>
									</div>
								</div>
							</div>
							{/* Profile Section ends */}
						</div>
					</div>
				</div>
			</nav>
			{/*Mobile sidebar*/}

			{/* Side menu Cubes  */}
			<div className="mobile-main-sidebar">
				<div className="inner">
					<ul className="icon-side-menu">
						{sideMenu?.top.map((menu, i) => {
							const isActive = window.location.pathname === menu.link;
							return (
								<li key={menu.id + "-" + i} className>
									<a
										href={menu.link}
										id={
											menu.name.toLowerCase().replace(/ /g, "") +
											"-sidebar-menu"
										}
										className={
											isActive
												? "is-selected is-active"
												: ""
										}
										dangerouslySetInnerHTML={{ __html: getIcon(menu.icon) }}
									/>
								</li>
							);
						})}
					</ul>

					<ul className="bottom-icon-side-menu">
						{sideMenu?.bottom.map((menu, i) => {
							const isActive = window.location.pathname === menu.link;
							return (
								<li key={menu.id + "-" + i}>
									<a
										href={menu.link}
										className={
											isActive
												? "is-selected is-selected is-active"
												: ""
										}
										dangerouslySetInnerHTML={{ __html: getIcon(menu.icon) }}
									/>
								</li>
							);
						})}
					</ul>
				</div>
			</div>

			{/* Side menu cubes */}

			{/*Circular menu*/}
			{!hideCircularMenu && <CircularMenu />}

			{/*Sidebar*/}
			<SideBar className="main-sidebar is-bordered">
				<div className="sidebar-brand is-bordered">
					<a href="/">
						<img
							className="light-image"
							src={require("../assets/images/logo.png").default}
							alt=""
						/>
						<img
							className="dark-image"
							src={require("../assets/images/logo.png").default}
							// src={require("../assets/img/logos/logo/logo-light.svg").default}
							alt
						/>
					</a>
				</div>
				<div className="sidebar-inner">
					<div className="naver" />
					<ul className="icon-menu">
						{/* Activity */}
						{sideMenu?.top.map((menu, i) => {
							const isActive = window.location.pathname === menu.link;
							return (
								<MenuItem 
									key={menu.id + "-" + i}
									active={isActive}
									>
									<MenuAnchor
										href={menu.link}
										id={
											menu.name.toLowerCase().replace(/ /g, "") +
											"-sidebar-menu"
										}
										data-content={menu.name.replace(/ /g, "")}
										className={
											isActive
												? "is-selected is-active"
												: ""
										}
										
									>
										{menu.unread > 0 && <div className="unread-counter">{menu.unread}</div>}
										<FeatherIcon icon={menu.icon} attr={{"class": "sidebar-svg" }} />
										<span>{menu.name}</span>
									</MenuAnchor>
								</MenuItem>
							);
						})}
					</ul>
					{/* User account */}
					<ul className="bottom-menu">
						{sideMenu?.bottom.map((menu, i) => {
							// const isActive = window.location.pathname.includes(menu.link);
							const isActive = window.location.pathname === menu.link;
							return (
								<MenuItem 
									key={menu.id + "-" + i}
									active={isActive}
									>
									<MenuAnchor
										href={menu.link}
										id={
											menu.name.toLowerCase().replace(/ /g, "") +
											"-sidebar-menu"
										}
										data-content={menu.name.replace(/ /g, "")}
										className={
											isActive
												? "is-selected is-active"
												: ""
										}
										
									>
										{menu.unread > 0 && <div className="unread-counter">{menu.unread}</div>}
										<FeatherIcon icon={menu.icon} attr={{"class": "sidebar-svg" }} />
										<span>{menu.name}</span>
									</MenuAnchor>
								</MenuItem>
							);
						})}
						{/* Profile */}
						<li id="user-menu">
							<div
								id="profile-menu"
								className={`dropdown profile-dropdown dropdown-trigger is-spaced is-up ${is_menu_active ? "is-active":""}`}
								onClick={() => set_is_menu_active(!is_menu_active)}
							>
								<img
									src={props?.user?.image || require("../assets/images/placeholder.png").default}
									alt=""
								/>
								
								<span className="status-indicator" />
								<div className="dropdown-menu" role="menu">
									<div className="dropdown-content">
										<div className="dropdown-head">
											<div className="h-avatar is-large">
												{props?.user?.image ? (
													<img
														className="avatar"
														src={props?.user?.image || require("../assets/images/placeholder.png").default}
														data-demo-src={props?.user?.image}
														alt={"Avatar"}
													/>
												) : (
													<span className="avatar is-fake text-uppercase">
														<span>{props?.user?.name?.substring(0,2).toUpperCase()}</span>
													</span>
												)}
											</div>
											<div className="meta">
												<span>{props?.user?.title} {props?.user?.name}</span>
												<span>{props?.user?.role}</span>
											</div>
										</div>
										{sideMenu.account.map((menu, i) => {
											if (menu.divider)
												return <hr className="dropdown-divider" />;
											return (
												<a href={menu.link} className="dropdown-item is-media">
													<div className="icon">
														{/* <i className={menu.icon} /> */}
														<FeatherIcon icon={menu.icon}  attr={{"class": "sidebar-svg" }} />
													</div>
													<div className="meta">
														<span>{menu.name}</span>
														<span >
															{menu.description}
															{menu.name === "eWallet" && (
																<>
																<hr className="dropdown-divider" />
																<strong>Balance:</strong> {toMoney(props?.user?.wallet?.balance)} 
																</>
														)} </span>
													</div>
												</a>
											);
										})}
										<hr className="dropdown-divider" />
										<div className="dropdown-item is-button">
											<button className="button h-button is-primary is-raised is-fullwidth logout-button"
											onClick={() => logout()}
											>
												<span className="icon is-small">
													<i data-feather="log-out" />
												</span>
												<span>Logout</span>
											</button>
										</div>
										<hr className="dropdown-divider" />										
										<div className="dropdown-item is-button">
											<button className="button h-button is-danger is-raised is-fullwidth logout-button"
											onClick={() => deleteAccountAlert()}
											>
												<span className="icon is-small">
													<i data-feather="delete" />
												</span>
												<span>Delete your account</span>
											</button>
										</div>																			
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</SideBar>
		</>
	);
};


const mapStateToProps = (state) => {
	return {
		user: state?.user?.user,
		wallet: state?.billing?.wallet
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		logout: (e) => dispatch(logout(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CombinedMenus);



const MenuAnchor = styled.a`
	display: flex !important;
	flex-direction: column;
	align-items: center;
	i  {
		background-color: #e0e0e0 !important;
		border-radius: 5px;
		width: 32.5px;
		height: 32.5px;
		display: flex;
		align-items: center;
		justify-content: center;
		svg {
			width: 18px !important;
			height: 18px !important;
			stroke: #37514b !important;
			font-weight: 600 !important;
			stroke-width: 2.5px !important;
		}
	}
`;

const MenuItem = styled.li`
	width: 100% !important;
	border-width: 0 !important;
	background: #f9f9f9 !important;
	border-radius: 0 !important;
	border-color: #f2f2f2;
	min-height: 100px;
	& span {
		color: #b3b5b6;
		font-size: 13px;
		margin-top: 10px;
	}
	
	${({ active }) => active && `
		& span {
			color: #37514b;
			font-weight: 600;
		}
		a > i { 
			background-color: #37514b !important;
			box-shadow: 0 2px 10px 3px rgba(255, 184, 28,0.63);
			-webkit-box-shadow: 0 2px 10px 3px rgba(255, 184, 28,0.63);
			-moz-box-shadow: 0 2px 10px 3px rgba(255, 184, 28,0.63);
			svg {
				stroke: #fff !important;
			}
		}
	`}

`;

const SideBar = styled.div`
	width: 110px !important;

	display: flex;
	flex-direction: column;
	align-items: center;

	& .sidebar-inner {
		margin-top: 20px;
	}

	& .bottom-menu {
		width: 100% !important;
		#user-menu {
			width: 100%;
			margin-top: 1.5em !important;
			margin-bottom: 1.5em !important;
		}
	}
`;